export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";